




import {Component, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {getStoredProcedure} from '@/data/repos/storedProcedure'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as complianceLinks from "@/data/sources/complianceLinks"

@Component({
  components: {
    DataGrid,
  },
})
export default class ComplianceExpiredElementsDrillDown extends Vue {
  public fields = [
    {name: 'ElementDescription', title: 'Element', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.element},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.building},
    {name: 'Code', title: 'Code', dataType: DataType.Text, sort: 1},
    {name: 'Reason', title: 'Reason', dataType: DataType.Text, sort: 1},
    {name: 'expirydate', title: 'Expiry Date', dataType: DataType.Date, sort: 1},
    {name: 'responsiblePerson', title: 'Responsible Person', dataType: DataType.Text, sort: 1},
    {name: 'riskLabel', title: 'Risk', dataType: DataType.Text, sort: 1},
    {name: 'Risk', title: 'Risk Value', dataType: DataType.Number, sort: 1},
  ]

  public getData(offset = 0, limit = 250) {
    const locationId = 10
    // INSERT INTO MY_TABLE(ElementId, ElementDescription, BuildingId, BuildingName, Code, Reason, expirydate, responsiblePerson, complianceElementLocationID, Risk, riskLabel) VALUES (7, 'Asbestos', 15595450, '2', '2', 'No Document', null, 'Ken Gordon', 588, 20, 'High');
    return getStoredProcedure(
      'AnalyticsCenter',
      'widget_ComplianceExpiredElementsDrillDown',
      [locationId, 1 /* user_id */],
      undefined,
      offset, limit)
  }
}
